import { NavLink, useLocation } from "react-router";
import { usePhone } from "../../../shared/phone/media";
import { Icon, type IconName } from "./Icon";

/** The portal's five places, in order: the same on a phone's tabs and an iPad's rail. */
export const PLACES: { to: string; label: string; icon: IconName }[] = [
  { to: "/home", label: "Home", icon: "home" },
  { to: "/referrals", label: "Referrals", icon: "people" },
  { to: "/assets", label: "Assets", icon: "image" },
  { to: "/payouts", label: "Payouts", icon: "coin" },
  { to: "/profile", label: "Account", icon: "user" },
];

/** The screens a tab opens. A screen pushed on top of one hides the bar, as on the phone. */
export function isTabRoot(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  return PLACES.some((t) => t.to === p);
}

/** The tabs along the bottom of a phone, shown only on a tab's own screen. */
export function TabBar() {
  const { pathname } = useLocation();
  const phone = usePhone();
  if (!phone || !isTabRoot(pathname)) return null;

  return (
    <nav className="pn-tabs" aria-label="Main">
      {PLACES.map(({ to, label, icon }) => (
        <NavLink key={to} to={to} className={({ isActive }) => (isActive ? "pn-tab on" : "pn-tab")} aria-label={label}>
          <Icon name={icon} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
